module.exports = __webpack_public_path__ + "img/Bowl-Sweet-Potato.e490d14a.jpg";